// stores/ui.js
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUIStore = defineStore('ui', () => {
  // Sidebar state
  const sidebarOpen = ref(true)
  const cameraPanelOpen = ref(false)
  const darkMode = ref(false)
  const activePage = ref('map')
  const selectedSite = ref(null)
  const showCameraList = ref(false)
  
  // Source filter untuk admin
  const adminSourceFilter = ref('all')
  const selectedCameraSource = ref('all')
  
  // Layer visibility - IMPORTANT: default true
  const showShipsLayer = ref(true)
  const showCamerasLayer = ref(true)

  const initFromStorage = () => {
    const savedSidebar = localStorage.getItem('sidebar_open')
    if (savedSidebar !== null) {
      sidebarOpen.value = savedSidebar === 'true'
    }
    
    const savedDarkMode = localStorage.getItem('dark_mode')
    if (savedDarkMode !== null) {
      darkMode.value = savedDarkMode === 'true'
    }
    
    const savedSourceFilter = localStorage.getItem('admin_source_filter')
    if (savedSourceFilter !== null) {
      adminSourceFilter.value = savedSourceFilter
    }
    
    const savedCameraSource = localStorage.getItem('selected_camera_source')
    if (savedCameraSource !== null) {
      selectedCameraSource.value = savedCameraSource
    }
    
    // Load layer visibility
    const savedShowShips = localStorage.getItem('show_ships_layer')
    if (savedShowShips !== null) {
      showShipsLayer.value = savedShowShips === 'true'
    }
    
    const savedShowCameras = localStorage.getItem('show_cameras_layer')
    if (savedShowCameras !== null) {
      showCamerasLayer.value = savedShowCameras === 'true'
    }
    
    console.log('UI Store initialized:', {
      showShips: showShipsLayer.value,
      showCameras: showCamerasLayer.value
    })
  }

  const toggleSidebar = () => {
    sidebarOpen.value = !sidebarOpen.value
    localStorage.setItem('sidebar_open', sidebarOpen.value)
  }

  const setSidebarOpen = (open) => {
    sidebarOpen.value = open
    localStorage.setItem('sidebar_open', sidebarOpen.value)
  }

  const toggleCameraPanel = () => {
    cameraPanelOpen.value = !cameraPanelOpen.value
  }

  const toggleDarkMode = () => {
    darkMode.value = !darkMode.value
    localStorage.setItem('dark_mode', darkMode.value)
    if (darkMode.value) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  const setActivePage = (page) => {
    activePage.value = page
    if (page !== 'cameras') {
      showCameraList.value = false
      selectedSite.value = null
    }
  }

  const setSelectedSite = (site) => {
    selectedSite.value = site
    showCameraList.value = true
  }

  const toggleCameraList = () => {
    showCameraList.value = !showCameraList.value
  }
  
  const setAdminSourceFilter = (source) => {
    adminSourceFilter.value = source
    localStorage.setItem('admin_source_filter', source)
  }
  
  const setSelectedCameraSource = (source) => {
    selectedCameraSource.value = source
    localStorage.setItem('selected_camera_source', source)
  }
  
  // Layer visibility methods
  const setShowShipsLayer = (visible) => {
    showShipsLayer.value = visible
    localStorage.setItem('show_ships_layer', visible)
  }
  
  const setShowCamerasLayer = (visible) => {
    showCamerasLayer.value = visible
    localStorage.setItem('show_cameras_layer', visible)
  }
  
  const toggleShipsLayer = () => {
    showShipsLayer.value = !showShipsLayer.value
    localStorage.setItem('show_ships_layer', showShipsLayer.value)
    return showShipsLayer.value
  }
  
  const toggleCamerasLayer = () => {
    showCamerasLayer.value = !showCamerasLayer.value
    localStorage.setItem('show_cameras_layer', showCamerasLayer.value)
    return showCamerasLayer.value
  }

  return {
    sidebarOpen,
    cameraPanelOpen,
    darkMode,
    activePage,
    selectedSite,
    showCameraList,
    adminSourceFilter,
    selectedCameraSource,
    showShipsLayer,
    showCamerasLayer,
    initFromStorage,
    toggleSidebar,
    setSidebarOpen,
    toggleCameraPanel,
    toggleDarkMode,
    setActivePage,
    setSelectedSite,
    toggleCameraList,
    setAdminSourceFilter,
    setSelectedCameraSource,
    setShowShipsLayer,
    setShowCamerasLayer,
    toggleShipsLayer,
    toggleCamerasLayer
  }
})